import React, { useCallback, useState } from 'react';

import AddItemForm from '../../components/ProductsServices/AddItemForm';
import AddProductForm from '../../components/ProductsServices/AddProductForm';
import AddServiceForm from '../../components/ProductsServices/AddServiceForm';
import ConfirmModal from '../../components/utils/ConfirmModal';

export default function ProductModalManager({ editingItem, showForm, onClose, refreshItems }) {
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleOverlayClick = useCallback(
    (e) => {
      if (!e.target.classList.contains('modal-overlay')) return;

      if (unsavedChanges) {
        setConfirmOpen(true);
        return;
      }

      onClose();
    },
    [unsavedChanges, onClose]
  );

  if (!editingItem && !showForm) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {editingItem ? (
          <div className="aim">
            <div className="aim-header">
              <h2>{editingItem.type === 'service' ? 'Edit Service' : 'Edit Product'}</h2>
              <button className="aim-close" onClick={onClose}>
                &times;
              </button>
            </div>
            <div className="aim-body">
              {editingItem.type === 'service' ? (
                <AddServiceForm
                  editingItem={editingItem}
                  refreshItems={refreshItems}
                  setUnsavedChanges={setUnsavedChanges}
                  onClose={onClose}
                />
              ) : (
                <AddProductForm
                  editingItem={editingItem}
                  refreshItems={refreshItems}
                  setUnsavedChanges={setUnsavedChanges}
                  onClose={onClose}
                />
              )}
            </div>
          </div>
        ) : (
          <AddItemForm
            refreshItems={refreshItems}
            setUnsavedChanges={setUnsavedChanges}
            onClose={onClose}
          />
        )}
      </div>

      <ConfirmModal
        isOpen={confirmOpen}
        title="Unsaved Changes"
        message="You have unsaved changes. If you close now, your changes will be lost."
        confirmLabel="Discard"
        destructive={true}
        onConfirm={() => { setConfirmOpen(false); onClose(); }}
        onCancel={() => setConfirmOpen(false)}
      />
    </div>
  );
}
